const BASE_API_URL = 'https://api.fidarsp.com';


export default class ApiClient {
  constructor() {
    this.baseUrl = BASE_API_URL;
  }

  async request(options) {
    let query = new URLSearchParams(options.query || {}).toString();
    if (query !== "") {
      query = "?" + query;
    }
    let lng;

    if (
      options.url.includes("/api/shop/products") ||
      options.url.includes("/api/blog/posts")
    ) {
      lng = `&locale=${localStorage.getItem("lng")}`;
    } else {
      lng = `locale=${localStorage.getItem("lng")}`;
    }

    if (options.url.includes("/comments?page=")) {
      lng = "";
    }

    if (options.url.includes("/comments")) {
      lng = "";
    }

    let response;
    try {
      response = await fetch(this.baseUrl + options.url + query + lng, {
        method: options.method,
        headers: {
          "Content-Type": "application/json",
          ...options.headers,
        },
        body: options.body ? JSON.stringify(options.body) : null,
      });

      const clonedResponse = response.clone();

      return {
        ok: response.ok,
        status: response.status,
        body: response.status !== 204 ? await clonedResponse.json() : null,
      };
    } catch (error) {
      console.log(options);
      response = {
        ok: false,
        status: 500,
        json: async () => {
          return {
            code: 500,
            message: "The server is unresponsive",
            description: error.toString(),
          };
        },
      };
      return response;
    }
  }

  async get(url, query, options) {
    return this.request({ method: "GET", url, query, ...options });
  }

  async uget(url, query, options) {
    return this.get(url, query, {
      headers: { Authorization: null },
      ...options,
    });
  }

  async post(url, body, options) {
    return this.request({ method: "POST", url, body, ...options });
  }

  async upost(url, body, options) {
    return this.post(url, body, {
      headers: { Authorization: null },
      ...options,
    });
  }

  async put(url, body, options) {
    return this.request({ method: "PUT", url, body, ...options });
  }

  async delete(url, options) {
    return this.request({ method: "DELETE", url, ...options });
  }
}
